import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import React from "react";
import { translate } from "react-i18next";

class ChartGender extends React.Component {
  filterData(data) {
    let result = data.filter((item) => {
      return item.value !== 0;
    });
    const { t } = this.props;
    result.forEach((item) => {
      if (item.class === "male") {
        item.name = t("male");
        item.key = t("male");
      } else if (item.class === "female") {
        item.name = t("female");
        item.key = t("female");
      } else {
        item.name = t("other");
        item.key = t("other");
      }
    });
    return result;
  }

  render() {
    let data = this.filterData(this.props.data);
    return (
      <ResponsiveContainer width={240} height={240}>
        <PieChart onMouseEnter={this.onPieEnter}>
          <Pie
            data={data}
            dataKey="value"
            cx={"50%"}
            cy={"50%"}
            innerRadius={"40%"}
            outerRadius={"100%"}
            styles={this.styles}
            fill="#8884d8"
          >
            {data.map((entry, index) => {
              return <Cell fill={entry.color} key={index} />;
            })}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
export default translate("translations")(ChartGender);
